import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import * as cardValidator from 'card-validator';

const PaymentInformationCreditDisplay = ({ source }) => {
	if (!source.cardNumber) return null;
	let type = '';
	let cardNumber = '';
	try {
		const card = cardValidator.number(source.cardNumber);
		let lastIndex = 0;
		for (let index = 0; index < card.card.gaps.length; index++) {
			const gap = card.card.gaps[index];
			cardNumber += source.cardNumber.slice(lastIndex, gap).replace(/./g, '*') + ' ';
			lastIndex = gap;
		}
		cardNumber += source.cardNumber.slice(lastIndex);
		type = card.card.type;
	} catch {
		cardNumber = source.cardNumber;
	}
	
	let icon = 'credit card';
	switch (type) {
		case 'visa':
			icon = 'cc visa';
			break;
		case 'mastercard':
			icon = 'cc mastercard';
			break;
		case 'american-express':
			icon = 'cc amex';
			break;
		default:
			icon = 'credit card';
			break;
	}

	return (
		<div>
			<Icon name={icon} />
			<div>{cardNumber}</div>
			<div>
				{source.cardExpireMonth}/{source.cardExpireYear}
			</div>
		</div>
	);
};

PaymentInformationCreditDisplay.propTypes = {
	source: PropTypes.object.isRequired
};

export default PaymentInformationCreditDisplay;
